import { render } from "./VideoManagment.vue?vue&type=template&id=2943d256"
import script from "./VideoManagment.vue?vue&type=script&lang=js"
export * from "./VideoManagment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__